module.exports = __webpack_public_path__ + "static/page-not-found-illustration-b373a55621711a4ee061287229f62499.svg";